import { SampledSeriesData, CHART_CONFIG } from './types';

export const validateSeriesData = (seriesArray: any[]): boolean => {
  return Array.isArray(seriesArray) && seriesArray.length > 0;
};

export const validateSeries = (series: any): boolean => {
  return series && series.data && Array.isArray(series.data);
};

export const isDrawdownChart = (sampledSeries: SampledSeriesData[]): boolean => {
  if (!sampledSeries.length) return false;

  const allValues = sampledSeries
    .flatMap(series => series.data.map(point => point.value))
    .filter((value): value is number => typeof value === 'number' && !isNaN(value));

  if (allValues.length === 0) return false;

  const stats = {
    negativeCount: allValues.filter(val => val <= 0).length,
    maxValue: Math.max(...allValues),
    minValue: Math.min(...allValues),
  };

  const negativePercentage = stats.negativeCount / allValues.length;

  return (
    negativePercentage >= CHART_CONFIG.DRAWDOWN_NEGATIVE_THRESHOLD &&
    stats.maxValue <= CHART_CONFIG.DRAWDOWN_MAX_VALUE &&
    stats.minValue >= CHART_CONFIG.DRAWDOWN_MIN_VALUE
  );
};
